module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/124.53fff9d4.png";